var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mpx-view',{staticClass:"consumer-hotline",style:((_vm.fontStyle)),on:{"tap":_vm.handleCall}},[_vm._v("客服电话："+_vm._s(_vm.number))])}
var staticRenderFns = []

export { render, staticRenderFns }